function wait(delay = 500, value = 'Timer') {
  return new Promise(resolve => setTimeout(resolve, delay, value));
}

export default wait;
